<template>
  <div class="drawer-wrap">
    <div @click="beforeOpen">
      <slot></slot>
    </div>
    <el-drawer
      title="编辑学员"
      :visible.sync="viewbtns"
      :modal-append-to-body="false"
      :size="420"
    >
      <div class="drawer_box">
        <el-form
          size="mini"
          ref="form"
          label-width="80px"
          class="drawer_form"
          :model="dialogForm"
          :rules="stydentrules"
        >
          <div class="drawer_Head">基本信息</div>
          <el-form-item label="用户照片:" class="drawerLenan_name">
            <avatar-cliper
              @change="handleFaceImageChange"
              :origin-url="dialogForm.source_avatar_url"
              :originName="dialogForm.avatar"
              :student-id="dialogForm.student_id"
            >
              <template v-slot="scope">
                <div
                  v-show="!scope.url"
                  style="width: 44px; height: 44px"
                ></div>
                <img
                  v-show="scope.url"
                  width="44"
                  height="44"
                  :src="scope.url"
                />
              </template>
            </avatar-cliper>
          </el-form-item>
          <el-form-item label="学员姓名:" prop="name">
            <el-input
              class="drawer_input"
              v-model="dialogForm.name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="手机号:"
            prop="mobile"
            v-if="dialogForm.show_mobile == 1"
          >
            <div class="phone-style">
              <div class="phone-style-left">
                <el-select
                  slot="prepend"
                  placeholder="请选择"
                  v-model.number="dialogForm.mobile_relation"
                  class="drawer_selectchoose"
                >
                  <el-option
                    v-for="item in mobileRelationList"
                    :key="item.value"
                    :label="item.value"
                    :value="Number(item.key)"
                  ></el-option>
                </el-select>
              </div>
              <div class="phone-style-right">
                <select-region-phone-number
                  @change="areaCode"
                  :areaCode="mySreaCodePhone.code"
                >
                  <div class="mwow-green curp">
                    <span
                      >{{ "+" + mySreaCodePhone.code }}
                      <i class="el-icon-arrow-down"></i
                    ></span>
                  </div>
                </select-region-phone-number>
              </div>
            </div>
            <el-input
              class="drawer_input"
              v-model="dialogForm.mobile"
              type="tel"
              placeholder="请输入手机号码"
              :maxlength="maxNum"
              @change="isDialogMobileChange = true"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="微信号:" prop="wechat">
            <el-input
              class="drawer_input"
              v-model="dialogForm.wechat"
              placeholder="请输入微信号"
              maxlength="15"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别:">
            <el-select
              v-model.number="dialogForm.sex"
              placeholder="请选择"
              class="drawer_onlychoose"
            >
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.value"
                :value="Number(item.key)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期:" class="drawer_chooseDate">
            <el-date-picker
              class="inputdate"
              type="date"
              placeholder="请选择"
              @change="dateChoose"
              value-format="timestamp"
              v-model="dialogForm.birthday"
              format="yyyy 年 MM 月 dd 日"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
            <div class="inputyear" v-if="dialogForm.age !== 0">
              {{ dialogForm.age }} 岁
            </div>
            <div class="inputyear" v-else>{{ ageMonth }} 个月</div>
          </el-form-item>
          <div class="drawer_Head">其他信息</div>
          <el-form-item label="教务老师:" v-if="dialogForm.status != 1">
            <div style="display: flex; align-items: center">
              <el-select
                :disabled="checkEduTeacherApi"
                v-model.number="dialogForm.teacher_id"
                filterable
                clearable
                placeholder="请选择"
                @clear="getSelectrList('teacher')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'teacher');
                  }
                "
              >
                <el-option
                  v-for="item in teacherName"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="Number(item.staff_id)"
                >
                </el-option>
              </el-select>
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p>用于接收学员请假等消息推送</p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item
            label="分配跟进:"
            prop="follow_staff_id"
            class="width-class"
          >
            <p style="color: #5c5d5e">
              （分配公海池，可被其他课程顾问看见并认领）
            </p>
            <div>
              <el-radio v-model="dialogForm.join_potential" :label="1"
                >课程顾问</el-radio
              >
              <el-radio
                v-model="dialogForm.join_potential"
                :label="2"
                :disabled="studentInfo.status !== 1"
                >公海池</el-radio
              >
            </div>
            <div v-if="dialogForm.join_potential === 1">
              <el-select
                :disabled="checkFollowStaffApi"
                v-model.number="dialogForm.follow_staff_id"
                filterable
                clearable
                placeholder="请选择课程顾问"
                @clear="getSelectrList('staff')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'staff');
                  }
                "
              >
                <el-option
                  v-for="item in staffName"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="Number(item.staff_id)"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="市场顾问:"
            prop="market_staff_id"
            class="staff-list"
          >
            <el-select
              v-model="dialogForm.market_staff_id"
              placeholder="请输入"
              clearable
              @clear="handleSearchMarketStaff('')"
              filterable
              :filter-method="handleSearchMarketStaff"
              @visible-change="handleMarketStaffVisible"
            >
              <el-option
                v-for="item in market_staff_list"
                :key="item.staff_id"
                :label="item.name"
                :value="item.staff_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="监护人:" v-if="dialogForm.show_mobile == 1">
            <div class="phone-style">
              <div class="phone-style-left">
                <el-select
                  slot="prepend"
                  placeholder="请选择"
                  v-model.number="dialogForm.guardian_relation"
                  class="drawer_selectchoose"
                >
                  <el-option
                    v-for="item in guardianList"
                    :key="item.value"
                    :label="item.value"
                    :value="Number(item.key)"
                  ></el-option>
                </el-select>
              </div>
              <div class="phone-style-right">
                <select-region-phone-number
                  @change="guardianAreaCode"
                  :areaCode="guardianSreaCodePhone.code"
                >
                  <div class="mwow-green curp">
                    <span
                      >{{ "+" + guardianSreaCodePhone.code }}
                      <i class="el-icon-arrow-down"></i
                    ></span>
                  </div>
                </select-region-phone-number>
              </div>
            </div>
            <el-input
              class="drawer_input"
              placeholder="请输入手机号码"
              v-model="dialogForm.guardian_mobile"
              type="del"
              :maxlength="guardianMaxNum"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="出现方式:" prop="appear_id">
            <div style="display: flex; align-items: center">
              <el-select
                placeholder="请选择"
                v-model.number="dialogForm.appear_id"
                class="drawer_onlychoose appears"
                @change="handleChangeAppear"
                :disabled="checkSourceTypeApi"
              >
                <el-option
                  v-for="item in studentAppearLabelList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                  :disabled="item.disable"
                ></el-option>
              </el-select>
              <el-popover
                placement="top"
                trigger="hover"
                popper-class="followuppopover"
              >
                <p>
                  出现方式主要统计学员来自哪种类型，<br />
                  且目前共5大类分别是；<br />
                  Walk_In：主动到访门店的客户；<br />
                  Call_In：主动打电话资讯的客户；<br />
                  Net_In：通过线上方式资讯的客户；<br />
                  Call_Out：被动获得的客户；<br />
                  转介绍：转介绍来的客户；<br />
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item label="来源渠道:" prop="source_type">
            <el-select
              placeholder="请选择"
              v-model="dialogForm.source_type"
              class="drawer_onlychoose"
              @visible-change="handleVisibleChange"
              :disabled="checkSourceTypeApi"
            >
              <el-option
                v-for="item in sourceTypeList"
                :key="item.source_id"
                :label="item.name"
                :value="Number(item.source_id)"
                :disabled="item.disable"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="家庭地址:">
            <el-input
              class="drawer_input"
              v-model="dialogForm.home_address"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="就读学校:">
            <el-input
              class="drawer_input"
              v-model="dialogForm.school"
              placeholder="请输入"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="意向科目：">
            <el-select
              class="drawer_input"
              v-model="dialogForm.subject_ids"
              multiple
              filterable
              remote
              default-first-option
              :remote-method="
                (queryString) => {
                  globalSearch(queryString, 'subject');
                }
              "
              placeholder="请选择科目"
            >
              <el-option
                v-for="item in subjectsList"
                :key="item.subject_id"
                :label="item.subject_title"
                :value="item.subject_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              type="textarea"
              class="drawer_input"
              :rows="3"
              v-model="dialogForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
          <div class="drawer_bottomBtn">
            <div class="mwow-button-filled mini reloadbtn" @click="closeView">
              取消
            </div>
            <div
              class="mwow-button-filled mini success reloadbtn"
              @click="postData('form')"
            >
              保存
            </div>
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import avatarCliper from "@/components/avatarCliper.vue";
import { studentDetail, studentedit } from "@/api/studyDetails";
import { PageModule } from "@/store/module/page";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import {
  addStudentGuardian,
  addMobileRelation,
  addsex,
} from "@/api/studentManage";
import { staffCheckApi } from "@/api/makeUpLessons";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import { getAge } from "@/utils/timeFormat";
import { waitingStudentClaimConfirm } from "@/utils/student-details";
import { getMarketStaffListApi } from "@/api/marketActivity";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";

export default {
  name: "editStudentDialog",
  components: {
    selectRegionPhoneNumber,
    avatarCliper,
  },
  props: ["studentInfo"],
  data() {
    return {
      guardianMaxNum: 11,
      maxNum: 11,
      mySreaCodePhone: {
        // 自己的手机区号
        checked: true,
        code: "86",
        code_id: 1,
        en_name: "China",
        name: "中国大陆",
      },
      guardianSreaCodePhone: {
        // 监护人手机区号
        checked: true,
        code: "86",
        code_id: 1,
        en_name: "China",
        name: "中国大陆",
      },
      viewbtns: false,
      stydentrules: {
        name: [{ required: true, message: "请输入名字", trigger: "blur" }],
        // mobile: [{ required: true, validator: phonePass, trigger: "blur" }],
        appear_id: [
          { required: true, message: "请选择学员出现方式", trigger: "change" },
        ],
        source_type: [
          { required: true, message: "请选择学员来源渠道", trigger: "change" },
        ],
      },
      dialogForm: {
        age: 0,
      },
      isDialogMobileChange: false,
      courseName: "", //课程名字
      className: "", //班级名字
      teacherName: "", //老师名字
      staffName: "", //员工名字
      sourceTypeList: [],
      guardianList: [],
      mobileRelationList: [],
      sexList: [],
      subjectsList: [],
      ageMonth: 0,
      checkEduTeacherApiPath: "/api/v1/student/edit/edu_teacher",
      checkFollowStaffApiPath: "/api/v1/student/edit/follow_staff",
      checkSourceTypeApiPath: "/api/v1/student/edit/source_type",
      checkEduTeacherApi: false,
      checkFollowStaffApi: false,
      checkSourceTypeApi: false,
      market_staff_list: [],
      pickerOptions: {
        //今天之前的
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 3600 * 1000;
        },
      },
      studentAppearLabelList: [],
    };
  },
  methods: {
    closeView() {
      this.viewbtns = false;
    },
    getFormList(cb, type) {
      const _t = this;
      cb().then((res) => {
        if (res.error_code == 0) {
          _t[type] = res.data.list;
        }
      });
    },
    dateChoose(e) {
      const _t = this;
      if (e < -2147483648 * 1000) {
        _t.$message({
          type: "error",
          message: "出生日期超出可选范围!",
        });
        _t.dialogForm.birthday = 0;
        _t.dialogForm.age = 0;
        _t.ageMonth = 0;
        return;
      }
      if (e != null) {
        const age = getAge(e);
        _t.dialogForm.age = age[0];
        _t.ageMonth = age[1];
      } else {
        _t.dialogForm.age = 0;
        _t.ageMonth = 0;
      }
    },
    // 通用搜索框
    getSelectrList(e) {
      const _t = this;
      _t.globalSearch("", e);
    },
    handleFaceImageChange(key) {
      // 用户照片更新
      this.dialogForm.avatar = key;
    },
    handleSolveData() {
      const _t = this;
      let option = {};
      if (_t.dialogForm.avatar) {
        option.avatar = _t.dialogForm.avatar;
      }
      if (_t.dialogForm.name) {
        option.name = _t.dialogForm.name;
      }
      if (_t.dialogForm.student_id) {
        option.student_id = _t.dialogForm.student_id;
      }
      if (_t.dialogForm.mobile) {
        option.mobile = _t.dialogForm.mobile;
      }
      if (_t.dialogForm.wechat) {
        option.wechat = _t.dialogForm.wechat;
      }
      if (!!_t.dialogForm.sex || _t.dialogForm.sex == "") {
        option.sex = _t.dialogForm.sex == "" ? 0 : _t.dialogForm.sex;
      }
      if (_t.dialogForm.birthday) {
        option.birthday = Math.floor(_t.dialogForm.birthday / 1000);
      } else {
        delete option.birthday;
      }
      if (_t.dialogForm.appear_id) {
        option.appear_id = Number(_t.dialogForm.appear_id);
      }
      if (_t.dialogForm.source_type) {
        option.source_type = Number(_t.dialogForm.source_type);
      }
      if (_t.dialogForm.home_address) {
        option.home_address = _t.dialogForm.home_address;
      }
      if (_t.dialogForm.school) {
        option.school = _t.dialogForm.school;
      }
      if (_t.dialogForm.subject_ids && _t.dialogForm.subject_ids.length > 0) {
        option.subject_ids = _t.dialogForm.subject_ids;
      }
      if (_t.dialogForm.remark) {
        option.remark = _t.dialogForm.remark;
      }
      if (this.mySreaCodePhone.code) {
        option.area_code = this.mySreaCodePhone.code;
      }
      if (this.guardianSreaCodePhone.code) {
        option.guardian_area_code = this.guardianSreaCodePhone.code;
      }
      if (_t.dialogForm.recruit_staff) {
        option.recruit_staff = _t.dialogForm.recruit_staff;
      }
      if (_t.dialogForm.market_staff_id) {
        option.market_staff_id = Number(_t.dialogForm.market_staff_id);
      }
      if (_t.dialogForm.teacher_id) {
        option.teacher_id = _t.dialogForm.teacher_id;
      }
      if (_t.dialogForm.join_potential) {
        option.join_potential = _t.dialogForm.join_potential === 2;
        if (
          _t.dialogForm.join_potential === 1 &&
          _t.dialogForm.follow_staff_id
        ) {
          option.follow_staff_id = _t.dialogForm.follow_staff_id;
        }
      }
      if (_t.dialogForm.guardian_relation) {
        option.guardian_relation = _t.dialogForm.guardian_relation;
      }
      if (_t.dialogForm.guardian_mobile) {
        option.guardian_mobile = _t.dialogForm.guardian_mobile;
      }
      if (_t.dialogForm.mobile_relation) {
        option.mobile_relation = _t.dialogForm.mobile_relation;
      }
      option.status = _t.dialogForm.status;
      if (_t.dialogForm.force) {
        option.force = _t.dialogForm.force;
      }
      option.ignore_exist_mobile = !_t.isDialogMobileChange; // 是否无视重复手机号
      return option;
    },
    // 编辑学员
    postData(formName) {
      const _t = this;
      _t.$refs[formName].validate((valid) => {
        // const data = { ..._t.dialogForm };
        let data = this.handleSolveData();
        if (valid) {
          studentedit(data).then((res) => {
            if (res.error_code == 0) {
              _t.$message({
                type: "success",
                message: "修改成功!",
              });
              _t.closeView();
              _t.$emit("recovery");
            } else if (res.error_code == 21009004) {
              _t.$confirm(
                `姓名与历史学员冲突，确定提交后将修改历史学员姓名，并随机生成后缀，例如：${_t.dialogForm.name}_asd0asdf`,
                `学员信息重复 - ${_t.dialogForm.name}`,
                {
                  confirmButtonText: "确定",
                  confirmButtonClass: "mwow-button-filled success mini",
                  cancelButtonText: "取消",
                  cancelButtonClass: "mwow-button-filled mini",
                  iconClass: "mwow-icon-error",
                }
              )
                .then(() => {
                  _t.dialogForm.force = 1;
                  _t.postData(formName);
                })
                .catch(() => {});
            } else if (res.error_code == 21009011) {
              _t.$confirm(
                "录入学员的手机号已存在，确认是否继续录入",
                "编辑学员-手机号已存在",
                {
                  confirmButtonText: "继续录入",
                  confirmButtonClass: "mwow-button-filled success mini",
                  cancelButtonText: "暂不录入",
                  cancelButtonClass: "mwow-button-filled mini",
                  iconClass: "mwow-icon-error",
                }
              )
                .then(() => {
                  _t.isDialogMobileChange = false;
                  _t.postData(formName);
                })
                .catch(() => {
                  _t.isDialogMobileChange = false;
                  _t.postData(formName);
                });
            } else {
              _t.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        data.job_ids = [3];
        return staffList(data);
      } else if (type == "teacher") {
        data.job_ids = [2];
        return staffList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      } else if (type == "subject") {
        data.status = 1;
        return getSeleSubjectsList(data);
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else if (type == "staff") {
          data.key_word = queryString;
        } else if (type == "subject") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      if (type == "subject") {
        data.page_size = 500;
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      } else if (type == "subject") {
        _t.subjectsList = list != null ? list : [];
      }
    },
    beforeOpen() {
      if (
        !this.studentInfo.follow_staff_id &&
        this.studentInfo.status === 1 &&
        this.studentInfo.is_potential === 1 &&
        this.$route.query.from === "waiting_student"
      ) {
        waitingStudentClaimConfirm({
          studentName: this.studentInfo.name,
          studentID: Number(this.studentInfo.student_id),
          claimSuccessCallback: () => {
            this.$emit("recovery");
            this.openDialog();
          },
        });
      } else {
        this.openDialog();
      }
    },
    // 通用搜索框结束
    async openDialog() {
      const _t = this;
      this.viewbtns = true;
      this.isDialogMobileChange = false;
      staffCheckApi({
        api_path: [
          this.checkEduTeacherApiPath,
          this.checkFollowStaffApiPath,
          this.checkSourceTypeApiPath,
        ],
      }).then((res) => {
        if (res.error_code === 0) {
          this.checkEduTeacherApi = !res.data[this.checkEduTeacherApiPath];
          this.checkFollowStaffApi = !res.data[this.checkFollowStaffApiPath];
          this.checkSourceTypeApi = !res.data[this.checkSourceTypeApiPath];
        }
      });
      _t.getDetails(
        {
          student_id: Number(this.studentInfo.student_id),
        },
        (data) => {
          _t.getFormList(addStudentGuardian, "guardianList");
          _t.getFormList(addMobileRelation, "mobileRelationList");
          _t.getFormList(addsex, "sexList");
          _t.globalSearch("", "teacher");
          getStudentAppearListApi({
            page: 1,
            page_size: 500,
          }).then((res) => {
            let appearList = [];
            res.data.list.map((a) => {
              if (a.status === 1) {
                appearList.push(a);
              } else {
                if (a.id === data.appear_id) {
                  appearList.push({
                    ...a,
                    disable: true,
                  });
                }
              }
            });
            this.studentAppearLabelList = appearList;
          });
          // _t.globalSearch("", "staff");
          // 旧员工离职或者不再是课程顾问的情况
          staffList({
            page: 1,
            page_size: 500,
            job_ids: [3],
          }).then((res) => {
            let list = res.data.list;
            if (data.follow_staff_id) {
              if (
                list.filter((staff) => {
                  return staff.staff_id === data.follow_staff_id;
                }).length === 0
              ) {
                list.push({
                  staff_id: data.follow_staff_id,
                  name: data.follow_staff_name,
                });
              }
            }
            this.staffName = list;
          });
          // 列表没有教务老师
          staffList({
            page: 1,
            page_size: 500,
            job_ids: [2],
          }).then((res) => {
            let list = res.data.list;
            if (data.teacher_id) {
              if (
                list.filter((staff) => {
                  return staff.staff_id === data.teacher_id;
                }).length === 0
              ) {
                list.push({
                  staff_id: data.teacher_id,
                  name: data.teacher_name,
                });
              }
            }
            this.teacherName = list;
          });
          _t.globalSearch("", "subject");
        }
      );
    },
    getDetails(id, cd) {
      const _t = this;
      if (!id) {
        this.$message({
          type: "error",
          message: "学员id不能为空",
        });
        return;
      }
      studentDetail(id).then((res) => {
        if (res.error_code == 0) {
          res.data.sex = res.data.sex == 0 ? "" : res.data.sex;
          res.data.guardian_relation =
            res.data.guardian_relation == 0 ? "" : res.data.guardian_relation;
          res.data.mobile_relation =
            res.data.mobile_relation == 0 ? "" : res.data.mobile_relation;
          res.data.birthday =
            Number(res.data.birthday + "000") == 0
              ? ""
              : Number(res.data.birthday + "000");
          res.data.follow_staff_id =
            res.data.follow_staff_id == 0 ? "" : res.data.follow_staff_id;
          if (res.data.market_staff) {
            res.data.market_staff_id = res.data.market_staff.staff_id;
            this.market_staff_list = [
              {
                name: res.data.market_staff.name,
                staff_id: res.data.market_staff.staff_id,
              },
            ];
          } else {
            res.data.market_staff_id = "";
          }
          res.data.appear_id =
            res.data.appear_id == 0 ? "" : res.data.appear_id;
          res.data.teacher_id =
            res.data.teacher_id == 0 ? "" : res.data.teacher_id;
          // 获取当前appear_id匹配渠道
          sourceTypeSelectListApi({
            appear_id: res.data.appear_id,
            status: 1,
          }).then((sourceRes) => {
            this.sourceTypeList = sourceRes.data.list;
            // 渠道已删除或禁用，无法在渠道列表中返回，该值不可选取
            if (
              !sourceRes.data.list.find((item) => {
                return (
                  item.source_id === res.data.student_source.student_source_id
                );
              })
            ) {
              this.sourceTypeList.push({
                source_id: res.data.student_source.student_source_id,
                name: res.data.student_source.name,
                disable: true,
              });
            }
          });
          if (res.data.student_subject.length != 0) {
            res.data.subject_ids = res.data.student_subject.reduce((a, b) => {
              a.push(b.subject_id);
              return a;
            }, []);
          }
          if (res.data.show_mobile == 0) {
            delete res.data.mobile;
            delete res.data.guardian_mobile;
          }
          _t.subjectsList = res.data.student_subject.map((item) => {
            return {
              subject_id: item.subject_id,
              subject_title: item.subject_title,
            };
          });
          const brithdayMonth = new Date(res.data.birthday).getTime();
          const date = new Date();
          if (res.data.age === 0 && res.data.birthday) {
            this.ageMonth = new Date(date.getTime() - brithdayMonth).getMonth();
          }
          // _t.dialogForm = res.data;
          this.getMarketStaffListApiFn();
          _t.dialogForm = {
            source_avatar_url: res.data.source_avatar_url,
            avatar: res.data.avatar,
            student_id: res.data.student_id,
            name: res.data.name,
            show_mobile: res.data.show_mobile,
            mobile_relation: res.data.mobile_relation,
            mobile: res.data.mobile,
            wechat: res.data.wechat,
            sex: res.data.sex,
            birthday: res.data.birthday,
            age: res.data.age,
            status: res.data.status,
            teacher_id: res.data.teacher_id,
            follow_staff_id: res.data.follow_staff_id,
            join_potential: res.data.is_potential === 1 ? 2 : 1,
            market_staff_id: res.data.market_staff
              ? res.data.market_staff.staff_id
              : "",
            guardian_relation: res.data.guardian_relation,
            guardian_mobile: res.data.guardian_mobile,
            appear_id: res.data.appear_id,
            source_type: res.data.source_type,
            home_address: res.data.home_address,
            school: res.data.school,
            subject_ids: res.data.subject_ids,
            remark: res.data.remark,
          };
          if (cd) {
            cd(res.data);
          }
          if (res.data.area_code) {
            this.mySreaCodePhone.code = res.data.area_code;
          }
          if (res.data.guardian_area_code) {
            this.guardianSreaCodePhone.code = res.data.guardian_area_code;
          }
        }
      });
    },
    areaCode(data) {
      PageModule.SET_PAGE_INFO({
        name: "areaCodePhoneNumber",
        key: "area_code",
        value: data[0].code,
      });
      if (data) {
        this.mySreaCodePhone = data[0];
        if (
          data[0].code !== "86" &&
          data[0].code !== "852" &&
          data[0].code !== "853" &&
          data[0].code !== "886"
        ) {
          this.maxNum = 16;
          return;
        } else if (data[0].code === "852" || data[0].code === "853") {
          this.maxNum = 8;
          return;
        } else if (data[0].code === "886") {
          this.maxNum = 10;
          return;
        } else {
          this.maxNum = 11;
          return;
        }
      }
    },
    guardianAreaCode(data) {
      PageModule.SET_PAGE_INFO({
        name: "guardianAreaCodePhoneNumber",
        key: "area_code",
        value: data[0].code,
      });
      if (data) {
        this.guardianSreaCodePhone = data[0];
        if (
          data[0].code !== "86" &&
          data[0].code !== "852" &&
          data[0].code !== "853" &&
          data[0].code !== "886"
        ) {
          this.guardianMaxNum = 16;
          return;
        } else if (data[0].code === "852" || data[0].code === "853") {
          this.guardianMaxNum = 8;
          return;
        } else if (data[0].code === "886") {
          this.guardianMaxNum = 10;
          return;
        } else {
          this.guardianMaxNum = 11;
          return;
        }
      }
    },
    handleChangeAppear() {
      sourceTypeSelectListApi({
        appear_id: this.dialogForm.appear_id,
        status: 1,
      }).then((res) => {
        this.sourceTypeList = res.data.list;
      });
      this.dialogForm.source_type = "";
    },
    handleVisibleChange(e) {
      if (e) {
        if (!this.dialogForm.appear_id) {
          this.sourceTypeList = [];
          return this.$message({
            message: "请选择出现方式",
            type: "warning",
          });
        }
      }
    },
    // 获取市场顾问列表
    getMarketStaffListApiFn(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
        status: 1,
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.getMarketStaffListApiFn(v);
    },
    // 市场顾问列表下拉
    handleMarketStaffVisible(rest) {
      if (rest) {
        this.getMarketStaffListApiFn();
      }
    },
    beforeDestroy() {
      PageModule.SET_PAGE_INFO({
        name: "areaCodePhoneNumber",
        key: "area_code",
        value: "",
      });
      PageModule.SET_PAGE_INFO({
        name: "guardianAreaCodePhoneNumber",
        key: "area_code",
        value: "",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.drawer-wrap {
  display: inline-block;
  .drawer_box {
    padding: 0 5%;
  }
  .drawer_Head {
    font-size: 14px;
    color: #5c5d5e;
    margin-bottom: 14px;
  }
  .drawer_bottomBtn {
    display: flex;
    justify-content: flex-end;
    max-width: 380px;
    .reloadbtn {
      margin-left: 12px;
    }
  }
  /deep/ .drawer_form {
    padding-top: 20px;
    .drawer_chooseDate {
      background: #fff;
      .inputdate {
        width: 175px;
        .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
      .inputyear {
        width: 85px;
        height: 28px;
        display: inline-block;
        text-align: center;
        border-radius: 0 4px 4px 0px;
        border: 1px solid #dcdfe6;
        vertical-align: middle;
        margin-left: -1px;
        text-align: center;
      }
    }
    .drawer_input {
      width: 260px;
      .el-input-group__prepend {
        background: #fff;
      }
    }
    .drawer_onlychoose {
      .el-input {
        width: 260px;
      }
    }
    .drawer_selectchoose {
      .el-input {
        width: 80px;
      }
      .el-input__inner {
        padding-left: 6px;
      }
    }
    .staff-list {
      .el-form-item__content {
        width: 260px;
        div:nth-child(1) {
          width: 100%;
        }
      }
    }
  }

  /deep/ .drawerLenan_name {
    .el-form-item__label {
      line-height: 44px !important;
    }
  }
  /deep/ .avatar-uploader {
    .el-upload {
      border: 1px dashed #e7e8ea;
      border-radius: 50%;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 44px;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
  .avatar {
    width: 44px;
    height: 44px;
    display: block;
  }
  .avatar-preview-wrap {
    position: relative;
    cursor: pointer;
    &:hover .shadow {
      display: block;
    }
    .image {
      border-radius: 50%;
    }
    .shadow {
      position: absolute;
      width: 44px;
      height: 44px;
      top: 0;
      left: 0;
      border-radius: 50%;
      background: rgba($color: #747474, $alpha: 0.7);
      display: none;
      line-height: 44px;
      text-align: center;
      .iconfont {
        color: #fff;
        font-size: 16px !important;
      }
    }
  }
}
/deep/ .phone-style {
  width: 260px;
  display: flex;
  margin-bottom: 12px;
  .phone-style-left {
    width: 50%;
    .el-input {
      width: 100% !important;
      .el-input__inner {
        border-radius: 4px 0 0 4px !important;
        text-align: center;
      }
      .el-input__icon {
        margin-right: 34px;
      }
    }
  }
  .phone-style-right {
    cursor: pointer;
    width: 50%;
    text-align: center;
    border: 1px solid #e7e8ea;
    border-left: none;
    border-radius: 0 4px 4px 0;
  }
}
.appears {
  /deep/ .el-input {
    width: 193px !important;
  }
}
.width-class {
  /deep/ .el-input {
    width: 260px !important;
  }
}
</style>
